import type { SymbolKey } from '@/entities/symbol';

export const exportPreviewKeys = {
  all: ['dataHub', 'exportPreview'] as const,
  lists: () => [...exportPreviewKeys.all, 'list'] as const,
  list: (filters: {
    symbolsKey: string[];
    from: string | null;
    to: string | null;
    includeMetadata: boolean;
    exportType: string;
    isCSV: boolean;
    userTimezone: string;
  }) => [...exportPreviewKeys.lists(), filters] as const,
  details: () => [...exportPreviewKeys.all, 'detail'] as const,
  detail: (id: string) => [...exportPreviewKeys.details(), id] as const
};

export const getSymbolsQueryKey = (symbols: SymbolKey[]) => {
  return symbols
    .map(symbol =>
      [symbol.Code, symbol.Period, symbol.PeriodType, symbol.TimeRef]
        .map(value => value ?? '')
        .join('|')
    )
    .sort((a, b) => a.localeCompare(b));
};
